import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import packageJson from '../../../../package.json';
// const packageJson = require('../../../../package.json');

@Injectable({
  providedIn: 'root',
})
export class CacheBusterService {
  private readonly buildDate = Number((packageJson as any).buildDate) || 0;
  private readonly isChecked = false;
  constructor(
    private http: HttpClient,
    private router: Router,
  ) {}

  init(): void {
    this.clearInitialCache();

    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.checkForNewBuild();
    });
  }

  private clearInitialCache(): void {
    const isCleared = localStorage.getItem('initialCacheCleared');
    if (isCleared !== 'Yes') {
      if ('caches' in window) {
        caches.keys().then((keys) => {
          Promise.all(keys.map((key) => caches.delete(key)))
            .then(() => {
              localStorage.setItem('initialCacheCleared', 'Yes');
            })
            .catch((err) => console.error('Initial cache clearing failed:', err));
        });
      }
    }
  }

  private checkForNewBuild(): void {
    const timestamp = new Date().getTime();

    this.http
      .get<{ buildDate: string | number }>(`/assets/meta.json?${timestamp}`, {
        headers: { 'Cache-Control': 'no-cache' },
      })
      .subscribe({
        next: (meta) => {
          const latestBuildDate = Number(meta.buildDate || 0);
          if (latestBuildDate > this.buildDate) {
            if ('caches' in window) {
              caches.keys().then((keys) => {
                Promise.all(keys.map((key) => caches.delete(key)))
                  .then(() => {
                    location.reload();
                  })
                  .catch((err) => console.error('Cache clearing failed:', err));
              });
            }
          }
        },
        error: (err) => console.error('An error occurred while fetching meta.json:', err),
      });
  }
}
